import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Paper,
    Box,
} from "@mui/material";
import { CircularProgressCustom } from "../../utils/muiCustomTheme";

interface EditHistoryTableProps {
    data?: any;
    isLoading?: boolean;
}

const EditHistoryTable: React.FC<EditHistoryTableProps> = ({ data, isLoading }) => {
    const historyData = data || [];
    const tableData = Array.isArray(historyData) ? historyData : [];


    const columns = [
        { field: "last_modified", headerName: "Edit date" },
        { field: "last_modified_by", headerName: "Edited By" },
    ];

    // Loading state
    if (isLoading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgressCustom />
            </Box>
        );
    }

    // No data state
    if (!tableData.length) {
        return <div className="create-campaign__delivery-preview__status">No edit history found for this campaign</div>;
    }

    return (
        <TableContainer component={Paper} sx={{ width: "100%" }}>
            <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                <TableHead>
                    <TableRow>
                        {columns.map((col) => (
                            <TableCell
                                key={col.field}
                                sx={{
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {col.headerName}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {tableData.map((row, index) => (
                        <TableRow
                            key={index}
                            sx={{
                                "&:hover": {
                                    backgroundColor: "#FFEBF5",
                                },
                            }}
                        >
                            <TableCell>
                                {row.last_modified
                                    ? new Date(row.last_modified).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "2-digit",
                                        year: "numeric",
                                    })
                                    : "-"}
                            </TableCell>
                            <TableCell>{row.last_modified_by || "-"}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default EditHistoryTable;
